import React from 'react';
import { Radio, RadioProps, useTheme } from '@mui/material';

const DSRadio: React.FC<RadioProps> = (props) => {
  const { palette } = useTheme();
  return (
    <Radio
      {...props}
      sx={{
        color: palette.text.primary,
        '&.Mui-checked': { color: palette.text.primary },
        ...props.sx,
      }}
    />
  );
};

export default DSRadio;
